import { useEffect, useRef } from "react";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Basiskarte: TopPlusOpen des Bundesamts für Kartographie und Geodäsie.
// Schlüsselfrei und ohne Zugriffsbeschränkung ("Es gelten keine
// Zugriffsbeschränkungen"), geldleistungsfrei unter dl-de/by-2-0 — also auch
// kommerziell nutzbar, solange der Quellenvermerk stehen bleibt. Ersetzt die
// CARTO-Basemap, die inzwischen "API KEY REQUIRED" in jede Kachel stempelt.
// Der Dienst liegt in Deutschland, was die Datenschutzlage zusätzlich entspannt.
// "web_light_grau" ist die hellgraue Variante — zurückhaltend genug, dass der
// Marker und die Flächenfarben der Anwendung darauf lesbar bleiben.
const TILE_URL =
  "https://sgx.geodatenzentrum.de/wmts_topplus_open/tile/1.0.0/web_light_grau/default/WEBMERCATOR/{z}/{y}/{x}.png";

// Quellenvermerk laut Dienst-Metadaten (ows:Fees) — verpflichtend.
const TILE_ATTRIBUTION =
  `Kartendarstellung: &copy; <a href="https://www.bkg.bund.de/">BKG</a> ${new Date().getFullYear()} ` +
  '<a href="https://www.govdata.de/dl-de/by-2-0">dl-de/by-2-0</a>, ' +
  '<a href="https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_topplusopen.html">Datenquellen</a>';

// Der WEBMERCATOR-TileMatrixSet endet bei Stufe 18; z19 liefert HTTP 400.
const TILE_MAX_ZOOM = 18;

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function MapView({ lat, lng, height = 320, zoom = 13 }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    if (!mapRef.current) {
      mapRef.current = L.map(containerRef.current, {
        zoomControl: true,
        scrollWheelZoom: false,
      }).setView([lat || 51.0, lng || 10.0], zoom);
      L.tileLayer(TILE_URL, {
        attribution: TILE_ATTRIBUTION,
        maxZoom: TILE_MAX_ZOOM,
      }).addTo(mapRef.current);
    }
    if (lat != null && lng != null) {
      mapRef.current.setView([lat, lng], zoom);
      if (markerRef.current) {
        markerRef.current.setLatLng([lat, lng]);
      } else {
        markerRef.current = L.marker([lat, lng]).addTo(mapRef.current);
      }
    }
  }, [lat, lng, zoom]);

  useEffect(() => () => {
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="map-view"
      style={{ height }}
      className="w-full rounded-lg overflow-hidden border border-[#E5E2D9] shadow-sm"
    />
  );
}
